module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ke-Lb.b7dffeda.png";